import { useMutation } from "@apollo/client";
import Button from "components/base/Button";
import Spinner from "components/base/Spinner";
import { Alert } from "components/base/Toast";
import { formatDate } from "react-day-picker/moment";
import { CONFIRM_PRODUCTION_FORM } from "./graphql";
import NewSupplierSubmitProductionInfoView from "./NewSupplierSubmitProductionInfoView";

const PreviewProductionForm = ({ previewForm, hide }) => {
  const data = JSON.parse(previewForm.data);

  const [confirm, { loading }] = useMutation(CONFIRM_PRODUCTION_FORM, {
    onCompleted: () => Alert("success", "Confirmed."),
    onError: (error) => Alert("error", error.message),
  });

  if (data instanceof Array)
    return (
      <div>
        <div>{formatDate(previewForm.createdAt, "YYYY-MM-DD")}</div>
        <div className="space-y-4 mt-4">
          {data.map((cat) => (
            <div key={cat.id}>
              <h4>{cat.name}</h4>
              <div className="opacity-60 mt-1">
                {cat.type === "BY_DAY" ? (
                  <div>{cat.qtyPerDay} / day</div>
                ) : (
                  <div>
                    {cat.timeList.map((time, timeIndex) => (
                      <div key={timeIndex}>
                        Qty: {time.qty} - {time.days} days.
                      </div>
                    ))}
                  </div>
                )}
              </div>
            </div>
          ))}
        </div>

        <div className="mt-8 flex space-x-8 relative">
          <Button
            onClick={() =>
              confirm({
                variables: { id: previewForm.id, confirmType: "accept" },
              })
            }
            disabled={loading}
          >
            Accept
          </Button>
          <Button
            danger
            onClick={() =>
              confirm({
                variables: { id: previewForm.id, confirmType: "reject" },
              })
            }
            disabled={loading}
          >
            Reject
          </Button>

          {loading ? <Spinner /> : null}
        </div>
      </div>
    );

  return (
    <NewSupplierSubmitProductionInfoView
      previewForm={previewForm}
      data={data}
      hide={hide}
    />
  );
};

export default PreviewProductionForm;
